import { render, staticRenderFns } from "./ExpandHeightHeader.vue?vue&type=template&id=21e3ce1c&"
import script from "./ExpandHeightHeader.vue?vue&type=script&lang=js&"
export * from "./ExpandHeightHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports